import Cookies from 'js-cookie'

export default {
  tokenName: 'JBF-EN-CONFIGURATION-TOOL',
  accoutName: 'JBF-EN-CONFIGURATION-TOOL-ACCOUNT',
  role: 'JBF-EN-CONFIGURATION-TOOL-ROLE',
  userId: 'JBF-EN-CONFIGURATION-TOOL-USERID',
  account: 'JBF-EN-CONFIGURATION-TOOL-LOGIN-ACCOUNT',
  password: 'JBF-EN-CONFIGURATION-TOOL-PASSWORD',
  language: 'JBF-EN-CONFIGURATION-TOOL-LANGUAGE',
  clearUserData () {
    Cookies.remove('JBF-EN-CONFIGURATION-TOOL')
    Cookies.remove('JBF-EN-CONFIGURATION-TOOL-ACCOUNT')
    Cookies.remove('JBF-EN-CONFIGURATION-TOOL-ROLE')
    Cookies.remove('JBF-EN-CONFIGURATION-TOOL-USERID')
  },
  checkEmail (email) {
    const re = /\w+@[a-z0-9]+\.[a-z]{2,4}/
    return re.test(email)
  },
  deepClone (obj) {
    if (typeof obj !== 'object' || obj === null) {
      return obj
    }
    var newObj = obj instanceof Array ? [] : {}
    for (var n in obj) {
      if (obj.hasOwnProperty(n)) {
        newObj[n] = this.deepClone(obj[n])
      }
    }
    return newObj
  },
  debounce (func, wait) {
    var timer
    return function () {
      var self = this
      var argus =  arguments
      clearTimeout(timer)
      timer = setTimeout(function () {
        func.apply(this, argus)
      }, wait)
    }
  },
  // 语言
  languageArr: [{
    name: 'English',
    spName: 'Inglés',
    poName: 'Inglês',
    value: 3
  }, {
    name: 'Spanish',
    spName: 'Español',
    poName: 'Espanhol',
    value: 2
  }, {
    name: 'Catalan',
    spName: 'Catalán',
    poName: 'Catalão',
    value: 4
  }, {
    name: 'Portuguese',
    spName: 'Portugués',
    poName: 'Português',
    value: 5
  }],
  // 账号状态
  accountStatus: [{
    name: 'All',
    spName: 'Todas',
    poName: 'Todas',
    value: 0
  }, {
    name: 'Activated',
    spName: 'Activado',
    poName: 'ativado',
    value: 1
  },
  {
    name: 'Inactivated',
    spName: 'Desactivado',
    poName: 'Inativado',
    value: 2
  },
  {
    name: 'Disabled',
    spName: 'Deshabilitado',
    poName: 'Desativado',
    value: 3
  }],
  // 设备类型 前端应该不需要维护，后端有接口查询
  deviceType: [{
    oriName: 'OD',
    name: 'Smoke Det.',
    spName: 'Det. Óptico',
    poName: 'Det. Ótico',
    value: 1
  }, {
    oriName: 'HD',
    name: 'Heat Det.',
    spName: 'Det. Térmico',
    poName: 'Det. Térmico',
    value: 2
  }, {
    oriName: 'MCP',
    name: 'MCP',
    spName: 'Pulsador',
    poName: 'Botoneira',
    value: 3
  }, {
    oriName: '1IM',
    name: 'Input Module',
    spName: 'Mod. Entrada',
    poName: 'Mod. Entrada',
    value: 4
  }, {
    oriName: 'IOM',
    name: 'IO Module',
    spName: 'Mod. E/S',
    poName: 'Mod. E/S',
    value: 5
  }, {
    oriName: 'OHD',
    name: 'Combo Det.',
    spName: 'Det. Ópt-Tér',
    poName: 'Det. Óti-Tér.',
    value: 6
  }, {
    oriName: 'SND',
    name: 'Sounder',
    spName: 'Sirena',
    poName: 'Sirene',
    value: 7
  },
  // {
  //   oriName: '1OM',
  //   name: '1OM',
  //   spName: '1OM',
  //   poName: '1OM',
  //   value: 8
  // }
],
  // 是否
  yesOrNo: [{
    name: 'yes',
    spName: 'Si',
    poName: 'sim',
    value: 1
  }, {
    name: 'no',
    spName: 'No',
    poName: 'Não',
    value: 0
  }],
  // 打印机电源状态
  powerArr: [{
    name: 'on',
    spName: 'activado',
    poName: 'ativo',
    value: 1
  }, {
    name: 'off',
    spName: 'Apagado',
    poName: 'desativo',
    value: 0
  }],
  // 打印机模式
  printMode: [{
    name: 'Spaced',
    spName: 'Espaciado',
    poName: 'Espaçado',
    value: 0
  }, {
    name: 'Dense',
    spName: 'Compacto',
    poName: 'Denso',
    value: 1
  }],
  // 打印选项
  printOption: [{
    name: 'All events',
    spName: 'Todos los eventos',
    poName: 'Todos os eventos',
    value: 1
  }, {
    name: 'Alarms',
    spName: 'Alarmas',
    poName: 'Alarmes',
    value: 2
  }, {
    name: 'Faults',
    spName: 'Avería',
    poName: 'Avarias',
    value: 3
  }, {
    name: 'Operator actions',
    spName: 'Acciones operador',
    poName: 'Ações do operador',
    value: 4
  }, {
    name: 'IO log',
    spName: 'Historico IO',
    poName: 'Registo de E/S',
    value: 5
  }],
  // 报警类型
  alarmTypeArr: [{
    name: 'MCP',
    spName: 'Pulsador',
    poName: 'Botoneira',
    value: 0
  }, {
    name: 'Detector',
    spName: 'Detector',
    poName: 'Detetor',
    value: 1
  }, {
    name: 'Input',
    spName: 'Entrada',
    poName: 'Entrada',
    value: 2
  }],
  // 事件类型
  eventTypeArr: [{
    name: 'All',
    spName: 'Todas',
    poName: 'Todas',
    value: 0
  }, {
    name: 'Fire',
    spName: 'Alarma',
    poName: 'Fogo',
    value: 1
  }, {
    name: 'Linkage',
    spName: 'Enlace',
    poName: 'Ligação',
    value: 2
  }, {
    name: 'Fault',
    spName: 'Avería',
    poName: 'Avaria',
    value: 3
  }, {
    name: 'Operator',
    spName: 'Operador',
    poName: 'Operador',
    value: 4
  }],
  // mark
  markArr: [{
    name: 'A',
    value: 'A'
  }, {
    name: 'B',
    value: 'B'
  }, {
    name: 'C',
    value: 'C'
  }, {
    name: 'D',
    value: 'D'
  }, {
    name: 'E',
    value: 'E'
  }, {
    name: 'F',
    value: 'F'
  }, {
    name: 'G',
    value: 'G'
  }, {
    name: 'H',
    value: 'H'
  }, {
    name: 'I',
    value: 'I'
  }, {
    name: 'J',
    value: 'J'
  }]
}
